<template>
  <TutorialSpotlight
    v-if="stop"
    :key="'help-' + code"
    :register="false"
    :target="stop.target"
    :title="$tut('tut.helpTitle')"
    :text="$tut('tut.help.' + code)"
    :counter="$tut('tut.pathTitle')"
    :next-label="$tut('tut.gotIt')"
    :mentor-icon="mentorIcon"
    :portrait="portrait"
    @next="close"
    @skip="close"
  />
</template>

<script>
/**
 * ПОМОЩЬ ПО ПУНКТУ «Пути новичка» (решение оунера 2026-07-30).
 *
 * Игрок нажимает на невыполненный пункт чек-листа в профиле → его уводит в нужный раздел, и здесь
 * наставник показывает, ЧТО именно нажать. Отличие от обычных подсказок обучения: это не шаг (он
 * ничего не двигает и не даёт награды), а помощь по запросу — закрывается кнопкой и живёт только
 * в памяти вкладки (`store.tutorial.helpCode`).
 *
 * Каждый экран монтирует компонент один раз: он сам решает, его ли это пункт (`SPOTS[code].route`).
 */
import TutorialSpotlight from '@/components/tutorial/TutorialSpotlight';
import { mentorIcon, mentorPortrait } from '@/components/tutorial/mentor';

// пункт чек-листа → куда вести и что подсвечивать в разделе
export const HELP_SPOTS = {
  win_pvp: { route: '/pvp', target: '.pvp-start' },
  equip_5: { route: '/pack', target: '.pk__chest-grid' },
  heal_unit: { route: '/pack', target: '.pk__frac-heal' },
  disassemble: { route: '/pack', target: '.pk__disasm-btn' },
  wheel_spin: { route: '/wheel', target: '.wheel__spin' },
  daily_chest: { route: '/daily', target: '.dq__panel' },
  // у этого пункта есть свой РАЗОВЫЙ обзор раздела — пока он не показан, помощь молчит (одно окно)
  market_visit: { route: '/market', target: '.market__tabs', tour: 'market' },
  market_sell: { route: '/market', target: '.market__tabs' },
  invite_friend: { route: '/profile', target: '.profile__referral' },
};

export default {
  name: 'TutorialHelp',
  components: { TutorialSpotlight },
  props: {
    // маршрут ЭТОГО экрана: показываем только «свои» пункты
    route: { type: String, required: true },
  },
  computed: {
    code() { return this.$store.getters.tutorialHelp; },
    stop() {
      const spot = HELP_SPOTS[this.code];
      if (!spot || spot.route !== this.route) return null;
      if (this.$store.getters.tutorialBusy) return null; // окно награды — сперва оно
      // подсказка ШАГА уже на экране → второй карточки наставника не рисуем (дубль диалогов)
      if (this.$store.getters.tutorialSpotOpen) return null;
      // разовый обзор раздела уже открыт → не рисуем поверх него вторую карточку наставника
      if (spot.tour && this.$store.getters.tutorialTours.includes(spot.tour)) return null;
      return spot;
    },
    portrait() { return mentorPortrait(this.$store.state.pvp.fraction); },
    mentorIcon() { return mentorIcon(this.$store.state.pvp.fraction); },
  },
  methods: {
    close() { this.$store.dispatch('closeTutorialHelp'); },
  },
};
</script>
